import React from 'react';
import { useNavigate } from 'react-router-dom';
import Nav from '../components/Nav';
import Chat from '../components/Chat';

function Home() {
  const navigate = useNavigate();

  return (
    <div>
      <Nav />
      <div className="page">
        <div className="hero">
          <h1 className="hero-title">
            the world inside <em>me</em>
          </h1>
          <p className="hero-sub">
            Every day has a story. Some I write, some I live in silence.
            This is my space. You're welcome to read, to feel, to talk.
          </p>
          <div className="hero-nav">
            <button className="hero-btn hero-btn-primary" onClick={() => navigate('/days')}>
              Read my days
            </button>
            <button className="hero-btn hero-btn-ghost" onClick={() => navigate('/thoughts')}>
              Random thoughts
            </button>
          </div>
        </div>
      </div>
      <Chat />
    </div>
  );
}

export default Home;
